/** from 위치의 항목을 to 위치로 옮긴 id 배열. */
export const movedOrder = (ids: readonly string[], from: number, to: number): string[] => {
  const next = [...ids];
  const [target] = next.splice(from, 1);

  if (target) {
    next.splice(to, 0, target);
  }

  return next;
};
